import { Injectable } from "@angular/core";
import {
  PRIMITIVE,
  ClientMessageBrokerFactory,
  FnArg,
  UiArguments,
} from "shared/provider-webworker";
import { ENCODABLE_TYPE_ERRORS } from "shared/broker-client-services";
import { ReplicaLookupService } from "../../impl/ReplicaLookupService";
import { IBlotterFilterPromiseLookupService } from "../IBlotterFilterPromiseLookupService";

import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

@Injectable()
export class BlotterFilterReplicaLookupService
  extends ReplicaLookupService<string, CubiqTS.BlotterFilterImpl>
  implements IBlotterFilterPromiseLookupService
{
  constructor(protected factory: ClientMessageBrokerFactory) {
    super(factory, CubiqTS.BlotterFilterImpl, "BlotterFilterImpl");
  }

  getMyBlotterFilters(): Promise<Array<CubiqTS.BlotterFilterImpl>> {
    let request = new UiArguments("getMyBlotterFilters");
    request.args = [];
    return this.broker.runOnService(request, this.VALUE);
  }

  getMySystemBlotterFilters(): Promise<Array<CubiqTS.BlotterFilterImpl>> {
    let request = new UiArguments("getMySystemBlotterFilters");
    request.args = [];
    return this.broker.runOnService(request, this.VALUE);
  }

  deleteItemsByIds(ids: string[]): Promise<boolean> {
    let request = new UiArguments("deleteItemsByIds");
    let arg1 = new FnArg(ids, PRIMITIVE);
    request.args = [arg1];
    return this.runOnService(request, this.VALUE);
  }

  createFilterItem(item: CubiqTS.BlotterFilterImpl): Promise<boolean> {
    let request = new UiArguments("createFilterItem");
    let arg1 = new FnArg(item, this.VALUE);
    request.args = [arg1];
    return this.runOnService(request, this.VALUE);
  }

  updateFilterItem(item: CubiqTS.BlotterFilterImpl): Promise<boolean> {
    let request = new UiArguments("updateFilterItem");
    let arg1 = new FnArg(item, this.VALUE);
    request.args = [arg1];
    return this.runOnService(request, this.VALUE);
  }

  protected runOnService(request: UiArguments, assignable: any = null): Promise<any> {
    return new Promise<any>((res, rej) => {
      this.broker.runOnService(request, PRIMITIVE).then((value: any) => {
        if (value && value.enType && value.enType == ENCODABLE_TYPE_ERRORS) {
          rej(value);
        } else {
          if (assignable && value) {
            value = Object.assign(assignable, value);
          }
          res(value);
        }
      });
    });
  }
}
